import useMyWorkspaces from '@hooks/query/provider/useMyWorkspaces';
import React from 'react';
import { TableSC } from './my-workspaces.styled';
import { useTableColumns } from './my-workspaces.utils';

const MyWorkspaces: React.FunctionComponent = () => {
  const { data, isFetching } = useMyWorkspaces();
  const columns = useTableColumns();

  return (
    <TableSC
      columns={columns}
      data={data ?? []}
      emptyTitle="Zatiaľ nepatríte pod žiadne ambulancie"
      showEmpty
      loading={isFetching}
      disableSortBy
    />
  );
};

export default React.memo(MyWorkspaces);
